import { customerProfileFormatter } from "../../utils/customer.utils";
import CustomerProfile from "./CustomerProfile";
import CustomerProfileContent from "./CustomerProfileContent";

export default function CustomerProfileContainer({ data }) {
  const formattedData = customerProfileFormatter(data);
  return (
    <div className="row">
      <div className="col-12 col-md-4">
        <CustomerProfile data={formattedData} />
      </div>
      <div className="col-12 col-md-8">
        <CustomerProfileContent data={formattedData} />
      </div>
    </div>
  );
}
